module.exports = __webpack_public_path__ + "ua.d0fdc636182666ae0ad0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ua.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ua.svg
// module chunks = styles